export default function ProblemSection() {
  return (
    <section className="relative py-16 md:py-24 px-4 md:px-8 lg:px-12 overflow-hidden bg-primary-500">
      <div className="relative z-10 max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-white mb-4">
            Caring for an elderly parent should not feel like <span className="text-accent-400">guesswork</span>
          </h2>
          <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed">
            Families often worry about whether Mom or Dad has taken their medication, eaten properly, remembered appointments, or knows what to do in an emergency.
          </p>
          <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed mt-3">
            CareBridge helps remove that worry by keeping the whole family connected around one simple care system.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/10 hover:border-white/20 transition-all duration-300">
            <div className="flex items-start gap-4 mb-5">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/15">
                <i className="ri-medicine-bottle-line text-secondary-400 text-xl"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-white mb-1">Missed medications</h3>
              </div>
            </div>
            <p className="text-sm text-white/85 leading-relaxed mb-6">
              Families do not always know if important medication has been taken.
            </p>
            <div className="flex items-baseline gap-2 pt-4 border-t border-white/10">
              <span className="text-2xl font-bold text-white">40%</span>
              <span className="text-xs text-white/75 uppercase tracking-wider">of seniors miss doses</span>
            </div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/10 hover:border-white/20 transition-all duration-300">
            <div className="flex items-start gap-4 mb-5">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/15">
                <i className="ri-chat-3-line text-accent-400 text-xl"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-white mb-1">Scattered communication</h3>
              </div>
            </div>
            <p className="text-sm text-white/85 leading-relaxed mb-6">
              Updates are often spread across phone calls, texts, WhatsApp, and memory.
            </p>
            <div className="flex items-baseline gap-2 pt-4 border-t border-white/10">
              <span className="text-2xl font-bold text-white">5+</span>
              <span className="text-xs text-white/75 uppercase tracking-wider">apps per family</span>
            </div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/10 hover:border-white/20 transition-all duration-300">
            <div className="flex items-start gap-4 mb-5">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/15">
                <i className="ri-alarm-warning-line text-accent-400 text-xl"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-white mb-1">Emergency worry</h3>
              </div>
            </div>
            <p className="text-sm text-white/85 leading-relaxed mb-6">
              When something happens, families need fast alerts and clear information.
            </p>
            <div className="flex items-baseline gap-2 pt-4 border-t border-white/10">
              <span className="text-2xl font-bold text-white">30 min</span>
              <span className="text-xs text-white/75 uppercase tracking-wider">average delay</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}